/**
@element com-calendar-button
@demo demo/index.html
*/
/*
  FIXME(polymer-modulizer): the above comments were extracted
  from HTML and may be out of place here. Review them and
  then delete this comment!
*/
import { PolymerElement, html } from '@polymer/polymer';
import './style/com-calendar-button-style.js';

import '@com/icon';

import { IronButtonState } from '@polymer/iron-behaviors/iron-button-state.js';
import { IronControlState } from '@polymer/iron-behaviors/iron-control-state.js';

import { mixinBehaviors } from '@polymer/polymer/lib/legacy/class.js';

class COMCalendarButton extends mixinBehaviors([
  IronButtonState,
  IronControlState
], PolymerElement) {
  static get template() {
    return html`
    <!-- Scoped styles for this element -->

    <style include="com-theme"></style>
    <style include="com-calendar-button-style"></style>
    <slot><div aria-hidden="true"><com-icon value="[[value]]"></com-icon></div></slot>
`;
  }

  static get is() { return 'com-calendar-button'; }

  static get properties() {
    return {
      /**
       * @desc icon code
       * @type String
       */
      value: {
        type: String
      },
      /**
       * @desc role for accessibility
       * @type String
       */
      role: {
        type: String,
        value: 'button',
        reflectToAttribute: true
      },
      /**
       * @desc tabindex
       * @type Number
       */
      tabindex: {
        type: Number,
        value: 0,
        reflectToAttribute: true
      },
      ariaLabel: {
        type: String,
        reflectToAttribute: true
      }
    }
  }

  /**
   * @desc Remove redundant 'aria-disabled' attribute in Prev and Next buttons
   * for A11Y, as disabled buttons are handled by the 'disabled' property instead.
   * @param {Boolean} disabled
   * @param {Boolean} old
   */
  _disabledChanged(disabled, old) {
    super._disabledChanged(disabled, old);
    this.removeAttribute('aria-disabled');
  }
}
customElements.define(COMCalendarButton.is, COMCalendarButton);
